export default __webpack_public_path__ + "static/media/oe-2-rMIN.8881ae98.jpg";